import { useEffect, useState } from "react";
import { format, parseISO, isValid } from "date-fns";
import { enGB } from "date-fns/locale";
import { CalendarDays, X } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";

const toDate = (v) => { const d = v ? parseISO(v) : null; return d && isValid(d) ? d : null; };
const DOB_CLASSES = { caption_dropdowns: "flex gap-1", caption_label: "hidden", vhidden: "hidden",
  dropdown: "rounded-md border border-border bg-white px-1 py-0.5 text-sm" };

export const ukDate = (v) => { const d = toDate(v); return d ? format(d, "dd/MM/yyyy") : (v || ""); };

export function UkDateInput({ value, onChange, testid, placeholder = "dd/mm/yyyy", min, max, dob = false, clearable = true, className = "" }) {
  const [open, setOpen] = useState(false);
  const d = toDate(value);
  const minD = toDate(min);
  const maxD = toDate(max);
  useEffect(() => { if (d && minD && d < minD) { onChange(""); } }, [value, min]); // eslint-disable-line react-hooks/exhaustive-deps
  const disabled = [minD && { before: minD }, maxD && { after: maxD }].filter(Boolean);
  const thisYear = new Date().getFullYear();
  const showClear = clearable && d;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <div className={`relative ${className}`}>
        <PopoverTrigger asChild>
          <button type="button" data-testid={testid}
            className={`flex w-full min-w-[9.5rem] items-center gap-2 rounded-lg border border-border bg-white py-2 pl-3 ${showClear ? "pr-8" : "pr-3"} text-left text-sm font-normal outline-none focus:border-brand focus:ring-2 focus:ring-brand/20`}>
            <CalendarDays size={15} className="shrink-0 text-ink-muted" />
            <span className={`whitespace-nowrap ${d ? "text-ink" : "text-ink-muted"}`} data-testid={`${testid}-value`}>{d ? format(d, "dd/MM/yyyy") : placeholder}</span>
          </button>
        </PopoverTrigger>
        {showClear && (
          <button type="button" onClick={() => onChange("")} data-testid={`${testid}-clear`} title="Clear date"
            className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-1 text-ink-muted hover:bg-secondary"><X size={13} /></button>
        )}
      </div>
      <PopoverContent className="z-[60] w-auto p-0" align="start">
        <Calendar mode="single" locale={enGB} weekStartsOn={1} selected={d || undefined}
          defaultMonth={d || (dob ? new Date(thisYear - 70, 0, 1) : (minD || maxD || undefined))} disabled={disabled}
          {...(dob ? { captionLayout: "dropdown-buttons", fromYear: 1900, toYear: thisYear, toDate: maxD || undefined, classNames: DOB_CLASSES } : {})}
          onSelect={(day) => { onChange(day ? format(day, "yyyy-MM-dd") : ""); setOpen(false); }} initialFocus />
      </PopoverContent>
    </Popover>
  );
}
